import React, { useCallback, useEffect, useRef, useState } from 'react'
import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Modal,
  Row,
  Select,
  Space,
  Steps,
  Tag,
  Tooltip,
  Upload,
} from 'antd'
import RichEditor from '../../../components/RichEditor/RichEditor'
import { ASSIGNEE_TYPE, DATE_FORMAT_LIST } from '../../../constants'
import {
  SelectList,
  SelectTitle,
} from '../../MissionCreatePage/MissionCreatePageStyled'
import { blue, redPrimary, yellowPrimary } from '../../../color'
import {
  BankOutlined,
  CloseOutlined,
  EditOutlined,
  TeamOutlined,
  UploadOutlined,
  UserOutlined,
} from '@ant-design/icons'
import { AvatarHasName } from '../../../components/Common/Avatar'
import { ButtonFooter } from '../PopupWorkForm/PopupWorkFormStyled'
import SelectPeoplePopup from '../../../components/SelectPeoplePopup/SelectPeoplePopup'
import SelectGroupPopup from '../../../components/SelectGroupPopup/SelectGroupPopup'
import { inject, observer } from 'mobx-react'
import loadingAnimationStore from '../../../stores/loadingAnimationStore'
import utils from '../../../utils'
import { toJS } from 'mobx'
import moment from 'moment'
import {
  CustomStepIcon,
  StepsWrapper,
} from '../../Documents/InternalDocumentSignDocPage/PopupCreateSignDoc/PopupCreateSignDocStyled'

const { Option } = Select
const { Step } = Steps

const PopupElectronicReleaseForm = props => {
  const {
    selectPeopleStore,
    isVisiblePopupElectronicRelease,
    workStore,
    handleCloseElectronicRelease,
    fileStore,
    authenticationStore,
  } = props

  const { workTypeList, workDetail, commentWorkList, groupVanThu } = workStore

  const {
    selectUserData,
    selectDepartmentData,
    selectGroupData,
    isVisibleSelectGroupPopup,
    setIsVisibleSelectGroupPopup,
    isVisibleSelectUserDepartmentPopup,
    setIsVisibleSelectUserDepartmentPopup,
    handleOpenSelectUserDepartmentPopup,
    handleCancelSelectUserDepartment,
    handleOpenSelectGroupPopup,
    handleCancelSelectGroup,
    clearSelectUserData,
  } = selectPeopleStore

  const [form] = Form.useForm()
  const EDITOR_REF = useRef()

  const { currentUser } = authenticationStore

  const [editorContent, setEditorContent] = useState(null)

  const [handlerList, setHandlerList] = useState([])
  const [followerList, setFollowerList] = useState([])
  const [leaderList, setLeaderList] = useState([])
  const [combinerList, setCombinerList] = useState([])
  const [departmentApproverList, setDepartmentApproverList] = useState([])
  const [formApproverList, setFormApproverList] = useState([])
  const [leaderApproverList, setLeaderApproverList] = useState([])
  const [numberIssuerList, setNumberIssuerList] = useState([])
  const [digitalSignerList, setDigitalSignerList] = useState([])
  const [releaserList, setReleaserList] = useState([])
  const [permission, setPermission] = useState([
    ASSIGNEE_TYPE.DEPARTMENT_APPROVER,
    ASSIGNEE_TYPE.FORM_APPROVER,
    ASSIGNEE_TYPE.LEADER_APPROVER,
    ASSIGNEE_TYPE.NUMBER_ISSUER,
    ASSIGNEE_TYPE.DIGITAL_SIGNER,
    ASSIGNEE_TYPE.RELEASER,
  ])
  const [stepsData, setStepsData] = useState([])

  const [electronicDocumentList, setElectronicDocumentList] = useState([])
  const [attachmentList, setAttachmentList] = useState([])
  const [attachments, setAttachments] = useState([])

  useEffect(() => {
    const allSteps = [
      {
        key: 1,
        title: 'Tạo dự thảo',
        userList: currentUser
          ? [
              {
                image_id: currentUser.imageId,
                full_name: currentUser.name_lowercase,
              },
            ]
          : [],
        allowDeleted: false,
      },
      {
        key: 2,
        title: 'Trưởng phòng duyệt',
        userList: departmentApproverList || [],
        allowDeleted: true,
        assignee_type: ASSIGNEE_TYPE.DEPARTMENT_APPROVER,
        permission: 'DEPARTMENT_APPROVER',
      },
      {
        key: 3,
        title: 'Duyệt thể thức',
        userList: formApproverList || [],
        type: 'approval',
        allowDeleted: true,
        assignee_type: ASSIGNEE_TYPE.FORM_APPROVER,
        permission: 'FORM_APPROVER',
      },
      {
        key: 4,
        title: 'Lãnh đạo duyệt',
        userList: leaderApproverList || [],
        type: 'approval',
        allowDeleted: true,
        assignee_type: ASSIGNEE_TYPE.LEADER_APPROVER,
        permission: 'LEADER_APPROVER',
      },
      {
        key: 5,
        title: 'Cấp số',
        userList: numberIssuerList || [],
        type: 'approval',
        allowDeleted: true,
        assignee_type: ASSIGNEE_TYPE.NUMBER_ISSUER,
        permission: 'NUMBER_ISSUER',
      },
      {
        key: 6,
        title: 'Ký số điện tử',
        userList: digitalSignerList || [],
        type: 'approval',
        allowDeleted: true,
        assignee_type: ASSIGNEE_TYPE.DIGITAL_SIGNER,
        permission: 'DIGITAL_SIGNER',
      },
      {
        key: 7,
        title: 'Phát hành',
        userList: releaserList || [],
        type: 'approval',
        allowDeleted: false,
        assignee_type: ASSIGNEE_TYPE.RELEASER,
        permission: 'RELEASER',
      },
    ]

    const filteredSteps = allSteps.filter(
      step => !step.permission || permission.includes(step.permission)
    )

    setStepsData(filteredSteps)
  }, [
    releaserList,
    currentUser,
    departmentApproverList,
    formApproverList,
    leaderApproverList,
    numberIssuerList,
    digitalSignerList,
    permission,
  ])

  useEffect(() => {
    const fileListFromComment = []
    commentWorkList &&
      commentWorkList.forEach(item => {
        if (!item.files || !Array.isArray(item.files)) return
        item.files.forEach(file => {
          fileListFromComment.push(file)
        })
      })
    const attachmentsDetail = workDetail.attachments || []
    setAttachments([...toJS(attachmentsDetail), ...toJS(fileListFromComment)])
  }, [workDetail, commentWorkList])
  useEffect(() => {
    ;(async () => {
      await clearSelectUserData()
    })()
  }, [selectPeopleStore])
  useEffect(() => {
    setLeaderList([...selectUserData[ASSIGNEE_TYPE.LEADER]])
    setCombinerList([...selectUserData[ASSIGNEE_TYPE.COMBINER]])
    setFollowerList([...selectUserData[ASSIGNEE_TYPE.FOLLOWER]])
    setDepartmentApproverList([
      ...(selectUserData[ASSIGNEE_TYPE.DEPARTMENT_APPROVER] || []),
      ...(selectDepartmentData[ASSIGNEE_TYPE.DEPARTMENT_APPROVER] || []),
      ...(selectGroupData[ASSIGNEE_TYPE.DEPARTMENT_APPROVER] || []),
    ])

    setFormApproverList([
      ...(selectUserData[ASSIGNEE_TYPE.FORM_APPROVER] || []),
      ...(selectDepartmentData[ASSIGNEE_TYPE.FORM_APPROVER] || []),
      ...(selectGroupData[ASSIGNEE_TYPE.FORM_APPROVER] || []),
    ])

    setLeaderApproverList([
      ...(selectUserData[ASSIGNEE_TYPE.LEADER_APPROVER] || []),
      ...(selectDepartmentData[ASSIGNEE_TYPE.LEADER_APPROVER] || []),
      ...(selectGroupData[ASSIGNEE_TYPE.LEADER_APPROVER] || []),
    ])

    setNumberIssuerList([
      ...(selectUserData[ASSIGNEE_TYPE.NUMBER_ISSUER] || []),
      ...(selectDepartmentData[ASSIGNEE_TYPE.NUMBER_ISSUER] || []),
      ...(selectGroupData[ASSIGNEE_TYPE.NUMBER_ISSUER] || []),
    ])

    setDigitalSignerList([
      ...(selectUserData[ASSIGNEE_TYPE.DIGITAL_SIGNER] || []),
      ...(selectDepartmentData[ASSIGNEE_TYPE.DIGITAL_SIGNER] || []),
      ...(selectGroupData[ASSIGNEE_TYPE.DIGITAL_SIGNER] || []),
    ])

    setReleaserList([
      ...(selectUserData[ASSIGNEE_TYPE.RELEASER] || []),
      ...(selectDepartmentData[ASSIGNEE_TYPE.RELEASER] || []),
      ...(selectGroupData[ASSIGNEE_TYPE.RELEASER] || []),
    ])
  }, [selectUserData, selectDepartmentData, selectGroupData])
  const onFinish = async value => {
    const code_work = workDetail?.code
    // if (handlerList.length === 0) {
    //   return message.info('Bạn chưa chọn lãnh đạo ký duyệt.')
    // }

    // if (!followerList.some(item => item.id === groupVanThu?.id)) {
    //   return message.info('Người theo dõi bắt buộc phải có nhóm văn thư.')
    // }

    const assigneesList = stepsData
      .filter(el => el.key !== 1)
      .map(el => ({
        assignee_code: el.userList[0] ? el.userList[0].id : '',
        assignee_type: el.userList[0] ? el.userList[0].assignee_type : 'USER',
        permission: el.permission,
      }))

    const permission = stepsData
      .filter(el => el.key !== 1)
      .map(el => el.permission)
      .join(',')

    const electronicFile = electronicDocumentList.find(item => item.checked)
    let idElectronicFile
    if (!electronicFile.originFileObj) {
      idElectronicFile = electronicFile.file_id
    } else {
      try {
        loadingAnimationStore.showSpinner(true)
        const formDataElectronic = new FormData()
        formDataElectronic.append('file', electronicFile.originFileObj)
        const { data } = await fileStore.uploadFile(formDataElectronic)
        idElectronicFile = data.file_id
      } catch (err) {
        console.log(err)
        message.error(err?.vi || 'Đã có lỗi xảy ra!')
      } finally {
        loadingAnimationStore.showSpinner(false)
      }
    }
    const attachmentData = attachmentList.filter(
      item => item.checked && !item.disabled
    )
    const attachmentUploaded = attachmentData
      .filter(item => !item.originFileObj)
      .map(item => item.file_id)
    const uploadAttachmentList = attachmentData
      .filter(item => item.originFileObj)
      .map(item => item.originFileObj)
    const batchUploadArr = []
    uploadAttachmentList.forEach(file => {
      const formData = new FormData()
      formData.append('file', file)
      batchUploadArr.push(fileStore.uploadFile(formData))
    })
    try {
      loadingAnimationStore.showSpinner(true)
      const response = await Promise.all(batchUploadArr)
      const uploadedFiles = response.map(response => response.data.file_id)
      const dataSubmit = {
        ...value,
        electronic_id: undefined,
        attachments: [...attachmentUploaded, ...uploadedFiles],
        file_id: idElectronicFile,
        assignees: assigneesList,
        parent_id: code_work,
        content: EDITOR_REF.current.editor.getData(),
        related_documents: [],
        permission: permission,
      }
      await workStore.createWork(dataSubmit)
      const responseDetail = await workStore.getWorkDetail(code_work)
      await workStore.getListSubWork(responseDetail.data.code)
      handleCancel()
      message.success('Tạo công việc thành công!')
    } catch (err) {
      console.log(err)
      message.error(err?.vi || 'Đã có lỗi xảy ra!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  useEffect(() => {
    setElectronicDocumentList(
      toJS(attachments)
        .filter(file =>
          ['pdf', 'doc', 'docx'].includes(
            utils.getExtensionFile(file.file_name)
          )
        )
        .map(item => ({
          ...item,
          checked: false,
        }))
    )
    setAttachmentList(
      toJS(attachments).map(item => ({
        ...item,
        disabled: false,
        checked: false,
      }))
    )
  }, [attachments])

  useEffect(() => {
    if (!groupVanThu || !isVisiblePopupElectronicRelease) return
    selectPeopleStore.setSelectGroupData({
      [ASSIGNEE_TYPE.HANDLER]: [],
      [ASSIGNEE_TYPE.COMBINER]: [],
      [ASSIGNEE_TYPE.FOLLOWER]: [
        {
          assignee_type: ASSIGNEE_TYPE.GROUP,
          full_name: groupVanThu.name,
          id: groupVanThu.id,
          permission: ASSIGNEE_TYPE.FOLLOWER,
        },
      ],
      [ASSIGNEE_TYPE.LEADER]: [],
    })
  }, [groupVanThu, isVisiblePopupElectronicRelease])

  useEffect(() => {
    if (isVisiblePopupElectronicRelease) {
      workStore.getGroupVanThu()
    }
  }, [isVisiblePopupElectronicRelease])

  // Validate select electronic document
  useEffect(() => {
    if (electronicDocumentList.length === 0) {
      form.setFieldsValue({
        electronic_id: undefined,
      })
      return
    }
    if (electronicDocumentList.some(item => item.checked)) {
      form.setFieldsValue({
        electronic_id: electronicDocumentList[0].file_id,
      })
    } else {
      form.setFieldsValue({
        electronic_id: undefined,
      })
    }
    const electronicDocumentChecked = electronicDocumentList.find(
      item => item.checked
    )
    const newAttachmentList = [...attachmentList].map(item => ({
      ...item,
      disabled: electronicDocumentChecked
        ? electronicDocumentChecked.file_id === item.file_id
        : false,
    }))
    setAttachmentList(newAttachmentList)
  }, [electronicDocumentList])

  const handleChangeElectronicDoc = info => {
    const originElectronicList = toJS(attachments)
      .filter(file =>
        ['pdf', 'doc', 'docx'].includes(utils.getExtensionFile(file.file_name))
      )
      .map(item => ({
        ...item,
        checked: false,
      }))
    const newList = [
      {
        file_id: info.file.uid,
        file_name: info.file.name,
        checked: true,
        originFileObj: info.file,
      },
      ...originElectronicList,
    ]
    setElectronicDocumentList(newList)
  }

  const onChangeElectronicDocumentCheckBox = info => {
    const newList = [...electronicDocumentList].map(item => ({
      ...item,
      checked: false,
    }))
    const fileTarget = {
      ...newList.find(item => item.file_id === info.target.value),
      checked: info.target.checked,
    }
    const indexFileTarget = newList.findIndex(
      item => item.file_id === info.target.value
    )
    newList[indexFileTarget] = fileTarget
    setElectronicDocumentList(newList)
  }

  const handleCancel = () => {
    handleCloseElectronicRelease()
    form.resetFields()
    selectPeopleStore.clearSelectUserData()
    selectPeopleStore.clearSelectDepartmentData()
    selectPeopleStore.clearSelectGroupData()
    selectPeopleStore.setSelectGroupData({
      [ASSIGNEE_TYPE.HANDLER]: [],
      [ASSIGNEE_TYPE.COMBINER]: [],
      [ASSIGNEE_TYPE.FOLLOWER]: groupVanThu
        ? [
            {
              assignee_type: ASSIGNEE_TYPE.GROUP,
              full_name: groupVanThu.name,
              id: groupVanThu.id,
              permission: ASSIGNEE_TYPE.FOLLOWER,
            },
          ]
        : [],
      [ASSIGNEE_TYPE.LEADER]: [],
    })
    setElectronicDocumentList(
      toJS(attachments)
        .filter(file =>
          ['pdf', 'doc', 'docx'].includes(
            utils.getExtensionFile(file.file_name)
          )
        )
        .map(item => ({
          ...item,
          checked: false,
        }))
    )
    setAttachmentList(
      toJS(attachments).map(item => ({
        ...item,
        disabled: false,
        checked: false,
      }))
    )
  }

  const handleChangeAttachment = info => {
    const newList = [
      ...info.fileList
        .map(item => ({
          file_id: item.uid,
          file_name: item.name,
          originFileObj: item.originFileObj,
          checked: true,
          disabled: false,
        }))
        .reverse(),
      ...attachmentList,
    ]
    const newAttachmentList = Array.from(
      new Set(newList.map(a => a.file_id))
    ).map(id => {
      return newList.find(a => a.file_id === id)
    })
    setAttachmentList(newAttachmentList)
  }

  const onChangeAttachmentCheckBox = info => {
    const newList = [...attachmentList]
    const fileTarget = {
      ...newList.find(item => item.file_id === info.target.value),
      checked: info.target.checked,
    }
    const indexFileTarget = newList.findIndex(
      item => item.file_id === info.target.value
    )
    newList[indexFileTarget] = fileTarget
    setAttachmentList(newList)
  }

  const handleRemoveStep = useCallback(
    key => {
      const newStepsData = stepsData.filter(step => step.key !== key)
      setStepsData(newStepsData)
      setPermission(
        newStepsData.filter(el => el.key !== 1).map(el => el.permission)
      )
    },
    [stepsData]
  )

  const existingStepKeys = useCallback(() => {
    return stepsData.map(step => step.key)
  }, [stepsData])

  const allSteps = [
    {
      key: 1,
      title: 'Tạo dự thảo',
      userList: currentUser
        ? [
            {
              image_id: currentUser.imageId,
              full_name: currentUser.name_lowercase,
            },
          ]
        : [],
      allowDeleted: false,
    },
    {
      key: 2,
      title: 'Trưởng phòng duyệt',
      userList: departmentApproverList ? departmentApproverList : [],
      allowDeleted: true,
      assignee_type: ASSIGNEE_TYPE.DEPARTMENT_APPROVER,
      permission: 'DEPARTMENT_APPROVER',
    },
    {
      key: 3,
      title: 'Duyệt thể thức',
      userList: formApproverList ? formApproverList : [],
      type: 'approval',
      allowDeleted: true,
      assignee_type: ASSIGNEE_TYPE.FORM_APPROVER,
      permission: 'FORM_APPROVER',
    },
    {
      key: 4,
      title: 'Lãnh đạo duyệt',
      userList: leaderApproverList ? leaderApproverList : [],
      type: 'approval',
      allowDeleted: true,
      assignee_type: ASSIGNEE_TYPE.LEADER_APPROVER,
      permission: 'LEADER_APPROVER',
    },
    {
      key: 5,
      title: 'Cấp số',
      userList: numberIssuerList ? numberIssuerList : [],
      type: 'approval',
      allowDeleted: true,
      assignee_type: ASSIGNEE_TYPE.NUMBER_ISSUER,
      permission: 'NUMBER_ISSUER',
    },
    {
      key: 6,
      title: 'Ký số điện tử',
      userList: digitalSignerList ? digitalSignerList : [],
      type: 'approval',
      allowDeleted: true,
      assignee_type: ASSIGNEE_TYPE.DIGITAL_SIGNER,
      permission: 'DIGITAL_SIGNER',
    },
    {
      key: 7,
      title: 'Phát hành',
      userList: releaserList ? releaserList : [],
      type: 'approval',
      allowDeleted: false,
      assignee_type: ASSIGNEE_TYPE.RELEASER,
      permission: 'RELEASER',
    },
  ]

  const handleAddStep = useCallback(
    key => {
      if (!key) return
      const stepToAdd = allSteps.find(step => step.key === key)
      if (stepToAdd) {
        const updatedSteps = prev => {
          const newSteps = [...prev, stepToAdd]
          newSteps.sort((a, b) => a.key - b.key)
          setPermission(
            newSteps.filter(el => el.key !== 1).map(el => el.permission)
          )
          return newSteps
        }

        setStepsData(updatedSteps)
      }
    },
    [allSteps]
  )

  const renderTitleStep = level => {
    return (
      <>
        <div>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <span>{level.title}</span>
            {level.key !== 1 && (
              <Tooltip title="Chọn người dùng" color={blue}>
                <Button
                  style={{ marginLeft: 8 }}
                  icon={<UserOutlined style={{ color: blue }} />}
                  onClick={() =>
                    handleOpenSelectUserDepartmentPopup(level.assignee_type)
                  }
                />
              </Tooltip>
            )}
          </div>
        </div>
      </>
    )
  }

  const renderDescStep = level => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginTop: level.allow_edit ? 6 : 14,
          marginBottom: 14,
        }}>
        {level.userList[0] ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Tag
              className={'tag-selected'}
              color={'blue'}
              closable={level.key === 1 ? false : true}
              onClose={() =>
                selectPeopleStore.handleRemoveSelect(level.userList[0])
              }>
              <AvatarHasName
                imgId={level.userList[0]?.image_id}
                size={22}
                name={level.userList[0]?.full_name}
              />
            </Tag>
          </div>
        ) : (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Tag style={{ borderRadius: 10 }}>Chưa gán người!</Tag>
          </div>
        )}
      </div>
    )
  }

  return (
    <Modal
      width={1000}
      style={{ top: 40 }}
      title={'Tạo công việc mới'}
      visible={isVisiblePopupElectronicRelease}
      maskClosable={false}
      onCancel={handleCancel}
      footer={null}>
      <Form
        onFinish={onFinish}
        form={form}
        layout="vertical"
        initialValues={{
          work_type: 'ELECTRONIC',
          title: 'Phát hành văn bản điện tử',
          start_date: moment(),
        }}>
        <Form.Item
          style={{ display: 'none' }}
          label={'Loại công việc'}
          name={'work_type'}
          rules={[{ required: true, message: 'Vui lòng chọn loại công việc' }]}>
          <Select
            className={'ant-disabled'}
            placeholder={'-- Chọn loại công việc --'}>
            {workTypeList.map(workType => (
              <Option
                disabled
                key={workType.id}
                value={workType.id}
                name={workType.name}>
                {workType.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label={'Tiêu đề:'}
          name={'title'}
          rules={[
            { required: true, message: 'Vui lòng nhập tiêu đề' },
            { max: 500, message: 'Tiêu đề không được dài quá 500 ký tự!' },
          ]}>
          <Input
            // className={'ant-disabled'}
            // disabled
            placeholder={'Nhập tiêu đề...'}
          />
        </Form.Item>

        <Form.Item label={'Nội dung:'} name={'content'}>
          <RichEditor
            EDITOR_REF={EDITOR_REF}
            placeholder={'Nhập nội dung...'}
            editorContent={editorContent}
          />
        </Form.Item>

        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item
              label={'Ngày bắt đầu:'}
              rules={[
                { required: true, message: 'Vui lòng chọn ngày bắt đầu!' },
              ]}
              name={'start_date'}>
              <DatePicker format={DATE_FORMAT_LIST} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label={'Ngày kết thúc:'} name={'due_date'}>
              <DatePicker format={DATE_FORMAT_LIST} />
            </Form.Item>
          </Col>
        </Row>
        <div>
          <Select
            placeholder="Chọn bước để thêm"
            value={null}
            onChange={value => {
              handleAddStep(value)
            }}
            style={{ width: 300 }}>
            {allSteps
              .filter(item => item.allowDeleted)
              .map(step => (
                <Option
                  key={step.key}
                  value={step.key}
                  disabled={existingStepKeys().includes(step.key)}>
                  {step.title}
                </Option>
              ))}
          </Select>
        </div>

        <StepsWrapper count={stepsData.length} i={4}>
          <Steps
            status="process"
            className={'steps'}
            labelPlacement={'vertical'}
            size={'small'}>
            {stepsData.map(level => {
              return (
                <Step
                  key={level.level}
                  title={renderTitleStep(level)}
                  description={renderDescStep(level)}
                  icon={
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <CustomStepIcon>{level.key} </CustomStepIcon>
                      {level.allowDeleted && (
                        <CloseOutlined
                          style={{ marginLeft: 6, fontSize: 12 }}
                          onClick={() => handleRemoveStep(level.key)}
                        />
                      )}
                    </div>
                  }
                />
              )
            })}
          </Steps>
        </StepsWrapper>
        <Form.Item
          label={'Chọn file trình ký:'}
          name={'electronic_id'}
          rules={[{ required: true, message: 'Vui lòng chọn file trình ký!' }]}>
          {
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <Upload
                accept={'.pdf,.docx,.docx'}
                valuePropName={'fileList'}
                fileList={electronicDocumentList}
                onChange={handleChangeElectronicDoc}
                showUploadList={false}
                beforeUpload={() => false}>
                <Button htmlType={'button'} style={{ marginBottom: 10 }}>
                  <UploadOutlined />
                  Chọn tài liệu trình ký khác
                </Button>
              </Upload>
              <Checkbox.Group
                value={
                  electronicDocumentList.find(item => item.checked)
                    ? electronicDocumentList.find(item => item.checked).file_id
                    : []
                }>
                <Space direction="vertical">
                  {electronicDocumentList.map(el => {
                    return (
                      <Checkbox
                        onChange={onChangeElectronicDocumentCheckBox}
                        key={el.file_id}
                        value={el.file_id}>
                        {el.file_name}
                      </Checkbox>
                    )
                  })}
                </Space>
              </Checkbox.Group>
            </div>
          }
        </Form.Item>
        <Form.Item label={'Chọn file đính kèm:'} name={'attachments'}>
          {
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <Upload
                multiple={true}
                showUploadList={false}
                valuePropName={'fileList'}
                onChange={handleChangeAttachment}
                beforeUpload={() => false}>
                <Button htmlType={'button'} style={{ marginBottom: 10 }}>
                  <UploadOutlined />
                  Chọn thêm tài liệu đính kèm
                </Button>
              </Upload>
              <Checkbox.Group
                value={attachmentList
                  .filter(item => item.checked)
                  .map(item => item.file_id)}>
                <Space direction="vertical">
                  {attachmentList.map(el => (
                    <Checkbox
                      onChange={onChangeAttachmentCheckBox}
                      key={el.file_id}
                      disabled={el.disabled}
                      value={el.file_id}>
                      {el.file_name}
                    </Checkbox>
                  ))}
                </Space>
              </Checkbox.Group>
            </div>
          }
        </Form.Item>
        <ButtonFooter>
          <Space>
            <Button icon={<CloseOutlined />} danger onClick={handleCancel}>
              Hủy
            </Button>
            <Button
              icon={<EditOutlined />}
              type={'primary'}
              htmlType={'submit'}>
              Tạo mới
            </Button>
          </Space>
        </ButtonFooter>
      </Form>
      <SelectPeoplePopup
        onlyOneUser={true}
        // onlyOneUser={
        //   selectPeopleStore.assigneePopupType === ASSIGNEE_TYPE.HANDLER
        // }
        handleCancelSelectUser={handleCancelSelectUserDepartment}
        handleSubmitSelectUser={() =>
          setIsVisibleSelectUserDepartmentPopup(false)
        }
        isVisibleSelectPeoplePopup={isVisibleSelectUserDepartmentPopup}
      />
      {/* <SelectGroupPopup
        isVisibleSelectGroupPopup={isVisibleSelectGroupPopup}
        handleCancelSelectGroup={handleCancelSelectGroup}
        handleSubmitSelectGroup={() => setIsVisibleSelectGroupPopup(false)}
      /> */}
    </Modal>
  )
}

PopupElectronicReleaseForm.propTypes = {}

export default inject(
  'selectPeopleStore',
  'workStore',
  'fileStore',
  'authenticationStore'
)(observer(PopupElectronicReleaseForm))
